
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/[handle]",
      function () {
        return require("private-next-pages/products/[handle].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/products/[handle]"])
      });
    }
  